export default function initMobileFixedTabs() {
	const tabElement = document.querySelector('.jsTriggerFixed');

	if (!tabElement) return;
	const scrollTriggerPos = tabElement.offsetTop + tabElement.offsetHeight;
	let targetId = tabElement.dataset.triggerId;
	let targetEl;

	if (targetId) {
		targetEl = document.getElementById(targetId)
	} else {
		targetEl = tabElement.cloneNode(true);
		targetEl.classList.remove('jsTriggerFixed');
		targetEl.classList.add('tabs-nav_sticky');
		tabElement.parentNode.appendChild(targetEl);
	}

    if (!targetEl) return;

	window.onscroll = () => {
		if (window.pageYOffset > scrollTriggerPos) {
			targetEl.classList.add('tabs-nav_fixed');
		} else {
			targetEl.classList.remove('tabs-nav_fixed');
		}
	};
}
